// src/components/AdminTeamManagement.js
import React, { useState } from 'react';
import { saveTeam } from '../services/firestoreService';
import { generateId } from '../services/utils'; // NEU: Import der generateId Funktion

const AdminTeamManagement = ({ companyUsers, teams, companyId, setNotification }) => {
    const [teamName, setTeamName] = useState('');
    const [editingTeam, setEditingTeam] = useState(null);
    const [members, setMembers] = useState([]);

    const handleCreateTeam = async () => {
        if (!teamName.trim()) {
            setNotification({ message: 'Bitte geben Sie einen Teamnamen ein.', type: 'error' });
            return;
        }
        const newTeam = { id: generateId(), name: teamName, members: [] }; // GEÄNDERT
        try {
            await saveTeam(newTeam, companyId);
            setNotification({ message: 'Team erfolgreich erstellt!', type: 'success' });
            setTeamName('');
        } catch (error) {
            console.error("Error creating team:", error);
            setNotification({ message: 'Fehler beim Erstellen des Teams.', type: 'error' });
        }
    };

    const handleSelectMember = (e) => {
        const userId = e.target.value;
        if (userId && !members.includes(userId)) setMembers([...members, userId]);
    };
    
    const handleRemoveMember = (userIdToRemove) => setMembers(members.filter(id => id !== userIdToRemove));

    const handleSaveTeamMembers = async () => {
        if (!editingTeam) return;
        const updatedTeam = { ...editingTeam, members };
        try {
            await saveTeam(updatedTeam, companyId);
            setNotification({ message: 'Teammitglieder gespeichert!', type: 'success' });
            setEditingTeam(null);
            setMembers([]);
        } catch (error) {
            setNotification({ message: 'Fehler beim Speichern der Mitglieder.', type: 'error' });
        }
    };
    
    const startEditing = (team) => {
        setEditingTeam(team);
        setMembers(team.members || []);
    };

    return (
        <div className="mt-8">
            <h3 className="text-2xl font-bold mb-4">Team-Verwaltung</h3>
            <div className="p-4 bg-gray-100 dark:bg-gray-900 rounded-lg">
                <h4 className="font-bold mb-2">Neues Team erstellen</h4>
                <div className="flex gap-2">
                    <input type="text" id="teamName" name="teamName" autoComplete="organization" placeholder="Teamname" value={teamName} onChange={(e) => setTeamName(e.target.value)} className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600" />
                    <button onClick={handleCreateTeam} className="px-4 py-2 bg-blue-600 text-white rounded-lg">Erstellen</button>
                </div>
            </div>
            <div className="mt-4">
                <h4 className="font-bold mb-2">Bestehende Teams</h4>
                {teams.map(team => (
                    <div key={team.id} className="p-4 mb-2 bg-gray-50 dark:bg-gray-800 rounded-lg">
                        <div className="flex justify-between items-center">
                           <p className="font-bold">{team.name}</p>
                           <button onClick={() => startEditing(team)} className="text-sm text-blue-500">Mitglieder verwalten</button>
                        </div>
                        {editingTeam?.id === team.id && (
                            <div className="mt-4">
                                <p>Mitglieder:</p>
                                <ul>
                                    {members.map(uid => {
                                        const user = companyUsers.find(u => u.uid === uid);
                                        return (
                                            <li key={uid} className="flex justify-between items-center">
                                                <span>{user ? `${user.firstName} ${user.lastName}` : 'Unbekannt'}</span>
                                                <button onClick={() => handleRemoveMember(uid)} className="text-red-500 text-xs">Entfernen</button>
                                            </li>
                                        );
                                    })}
                                </ul>
                                <select id="add-member-select" name="add-member-select" onChange={handleSelectMember} className="w-full mt-2 p-2 border rounded dark:bg-gray-700 dark:border-gray-600">
                                    <option value="">Benutzer hinzufügen...</option>
                                    {companyUsers.filter(u => !members.includes(u.uid)).map(user => (
                                        <option key={user.uid} value={user.uid}>{user.firstName} {user.lastName}</option>
                                    ))}
                                </select>
                                <button onClick={handleSaveTeamMembers} className="mt-2 px-4 py-2 bg-green-600 text-white rounded-lg">Speichern</button>
                                <button onClick={() => setEditingTeam(null)} className="mt-2 ml-2 px-4 py-2 bg-gray-300 rounded-lg">Abbrechen</button>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AdminTeamManagement;
